import React, { Component, Fragment } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { connect } from 'react-redux'
//import { handleInitialData } from '../actions/shared'
import LoadingBar from 'react-redux-loading'
import Header from './Header'
import InfoHeader from './InfoHeader'
import Dashboard from './Dashboard'
import Page404 from './Page404'

class App extends Component {
  componentDidMount(prevProps, prevState) {
    //this.props.dispatch(handleInitialData())
  }

  render() {
    const { loading } = this.props

    const theme = createMuiTheme({
      overrides: {
        MuiFormLabel: {
          asterisk: {
            color: '#e30613',
            '&$error': {
              color: '#e30613'
            },
          }
        }
      }
    })

    return (
      <MuiThemeProvider theme={theme}>
        <Router>
          <Fragment>
            <LoadingBar className='loadingBar' />
            <Header />
            <InfoHeader />

            <div className='container'>
              {loading === true
                ? null
                : <Fragment>
                  <Route path='/:name/:hashId' component={Dashboard} />
                  <Route path='/404' component={Page404} />
                </Fragment>}
            </div>
          </Fragment>
        </Router>
      </MuiThemeProvider>
    )
  }
}

function mapStateToProps({ rfpData, questions }) {
  return {
    loading: Object.keys(questions).length === null,
  }
}

export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/components/App.js